import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CookieService } from 'src/app/core/services/cookie.service';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss'],
})
export class ConfirmComponent implements OnInit, AfterViewInit {
  obj = {
    "Id" : ''
  };
  currentUser: any;
  errorMessage: any;
  constructor(private service: GeneralService, private formBuilder: FormBuilder, private router: Router, private cookieservice: CookieService) { }
  @ViewChild('emailOtpInput', { static: false }) emailOtpInputRef: any;
  userID: number;
  resendOTP = false;
  OTPform: FormGroup;
  submitted = false;
  error = '';
  loading = false;
  submitdata = {
    "Id": '',
    "OTP": '',
  };
  time = 5 * 60;
  response: any;
  ngOnInit() {
    this.currentUser = JSON.parse(this.cookieservice.getCookie('currentUser'));
    this.userID = this.currentUser;
    // this.userID = 16;
    this.OTPform = this.formBuilder.group({
      EMAILOTP: ['', Validators.compose([Validators.required, Validators.pattern('[a-zA-Z0-9]{6}')])],
    });
    this.timer();
  }
  timer() {
    const intervel = setInterval(() => {
      if (this.time > 0.5) {
        this.time -= 1;
      } else {
        clearInterval(intervel);
        this.resendOTP = true;
      }
    }, 1000);
  }
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.OTPform.invalid) {
      return;
    }
    this.submitdata.OTP = this.OTPform.value.EMAILOTP;
    this.submitdata.Id = this.userID.toString();
    this.loading = true;
    this.service.validateOTP(this.submitdata).subscribe((res) => {
      if (res.error) {
        this.error = res.error;
        this.loading = false;
        return;
      } else if(res.message && res.status == 401) {
        this.error = res.message;
        this.loading = false;
      } else {
        Swal.fire({
          position: 'top-end',
          type: 'success',
          title: res.message,
          showConfirmButton: false,
          timer: 1500
        });
        this.loading = false;
        this.cookieservice.setCookie('currentUser', JSON.stringify(res.data), 1);
        console.log(res.userType);
        if((res.userType && res.userType != null))
        {
          console.log(res.userType);
          this.router.navigate(['/epp']);
        } else {
          this.router.navigate(['/new-user']);
        }
      }

    },
    (error) => {                              //Error callback
      this.loading = false;
      Swal.fire({
        title: error.status,
        text: "Internal Server Error",
        type: "error",
      });
      //throw error;   //You can also throw the error to a global error handler
    });
  }
  onEmailOtpChange(event) {
    this.OTPform.controls.EMAILOTP.setValue(event);
  }
  reSendOTP() {
    this.cleanOTPBox();
    this.time = 5 * 60;
    this.resendOTP = false;
    this.obj.Id = this.userID.toString();
    this.timer();
    this.service.generateOTP(this.obj).subscribe((res) => {
      Swal.fire({
        position: 'top-end',
        type: 'success',
        title: res.Message,
        showConfirmButton: false,
        timer: 1500
      });
    },
    (error) => {                              //Error callback
      this.loading = false;
      Swal.fire({
        title: error.status,
        text: "Internal Server Error",
        type: "error",
      });
      //throw error;   //You can also throw the error to a global error handler
    });
  }
  ngAfterViewInit() {
    document.body.classList.add('authentication-bg');
    document.body.classList.add('authentication-bg-pattern');
  }
  cleanOTPBox() {
    this.emailOtpInputRef.setValue('');
  }
  get f() { return this.OTPform.controls; }
}
